/*
 * Quelle entrée du rail est active.
 *
 * Le calcul est fait À L'ÉCHELLE DU RAIL et non entrée par entrée, parce que la
 * réponse dépend des voisines : sur /tutor/enfant/s1/chat, « Devoirs »
 * (/tutor/enfant/s1) et « Discuter avec Naïa » matchent toutes deux par préfixe,
 * et seule la seconde doit s'allumer. Un booléen calculé isolément ne peut pas
 * le savoir — d'où la liste en dur `exactOnly` puis le paramètre `exclude` qui
 * la rapiéçaient, l'une et l'autre à tenir à la main.
 *
 * Deux règles suffisent et remplacent les deux rustines :
 *  · comparaison par SEGMENT, jamais par chaîne — /admin/users ne matche pas
 *    /admin/users-schools, qui n'en est pas un descendant ;
 *  · la plus LONGUE gagne — une route orpheline s'allume donc sur son ancêtre
 *    le plus proche, ce qui dit à l'utilisateur où il se trouve.
 */

/** `to` couvre-t-il `current` ? Vrai pour lui-même et ses descendants. */
export function covers(to: string, current: string): boolean {
  return current === to || current.startsWith(`${to}/`);
}

/**
 * L'entrée active parmi les candidates, ou null. Une seule par construction :
 * c'est la plus longue qui couvre le chemin courant.
 */
export function activeRailPath(candidates: readonly string[], current: string): string | null {
  let best: string | null = null;
  for (const to of candidates) {
    if (!covers(to, current)) continue;
    if (best === null || to.length > best.length) best = to;
  }
  return best;
}
